import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import Services from '@/views/Services'
import Contact from '@/views/Contact'
import Legals from '@/views/Legals'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
    ,
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/mentions_legales',
      name: 'mentions_legales',
      component: Legals
    }
  ]
})
